const sortNomeFunction = (a: any, b: any) => {
  return a.nome.toUpperCase() < b.nome.toUpperCase() ? -1 : a.nome.toUpperCase() > b.nome.toUpperCase() ? 1 : 0;
};

const sortTituloFunction = (a: any, b: any) => {
  return a.titulo.toUpperCase() < b.titulo.toUpperCase() ? -1 : a.titulo.toUpperCase() > b.titulo.toUpperCase() ? 1 : 0;
};

export const sortOptionsFunction = (a: any, b: any) => {
  return a.label.toUpperCase() < b.label.toUpperCase() ? -1 : a.label.toUpperCase() > b.label.toUpperCase() ? 1 : 0;
};

const SortHelper = {
  sortNomeFunction: sortNomeFunction,
  sortOptionsFunction: sortOptionsFunction,
  sortTituloFunction: sortTituloFunction,
};

export default SortHelper;
